import { NgModule } from '@angular/core';
import { TimeLeftPipe } from './time-left.pipe';
import { TimeLeftTranslationComponent } from './time-left-translation.component';
import { TimeLeftTranslationService } from './time-left-translation.service';
import { TranslationModule } from '@schoolbelle/common/translation';


@NgModule({
  imports : [
    TranslationModule.forRoot(),
  ],
  declarations: [
    TimeLeftPipe,
    TimeLeftTranslationComponent,
  ],
  providers:[
    TimeLeftTranslationService,
  ],
  exports:[
    TimeLeftPipe    
  ],
  entryComponents: [TimeLeftTranslationComponent]
})
export class TimeLeftPipeModule { }


